var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coach-admin-master-list"},[_c('div',{staticClass:"coach-admin-master-list-wrapper"},_vm._l((_vm.coachAdmins),function(coachAdmin){return _c('CoachAdminCard',{key:coachAdmin.id,attrs:{"coach-admin":coachAdmin}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }